import { useLayoutEffect, type RefObject } from 'react';

/**
 * Marks the element as arriving, its `data-arriving` set, for `duration` each time it's shown, so
 * an entrance inside it plays as it opens and not for what appears in it later (the Studio's, in
 * input-panel.css). Set before the first paint, so nothing shows before its entrance starts.
 */
export function useArrival(
  ref: RefObject<HTMLElement | null>,
  shown: boolean,
  duration: number,
): void {
  useLayoutEffect(() => {
    const element = ref.current;
    if (!element || !shown) return;
    element.dataset.arriving = '';
    const timer = window.setTimeout(() => {
      delete element.dataset.arriving;
    }, duration);
    return () => {
      window.clearTimeout(timer);
      delete element.dataset.arriving;
    };
  }, [ref, shown, duration]);
}
